/**
 * Created by ganlu on 27/12/2016.
 */
export default ($compile, $rootScope, $http, $parse, $timeout) => {

    "ngInject";

    return {
        restrict: 'A',
        link: fancyboxableLink,
        priority: 100
    };

    ////////////////////////////

    function fancyboxableLink($scope, $element, $attributes, controller) {
        let fbp = null;

        $scope.$on('$destroy', function () {
            $element.remove();
        });

        init();

        function init(open) {
            let options = {
                href: $attributes.src ? $attributes.src : $attributes.href,
                onComplete: function () {
                    onComplete();
                }
            };

            //generic way that sets all (non-function) parameters of fancybox-plus.
            if ($attributes.fancyboxable && $attributes.fancyboxable.length > 0) {
                let fbpOptionsFunc = $parse($attributes.fancyboxable);
                let fbpOptions = fbpOptionsFunc($scope);
                angular.extend(options, fbpOptions);
            }

            //clean undefined
            for (let key in options) {
                if (options.hasOwnProperty(key)) {
                    if (typeof(options[key]) === 'undefined') {
                        delete options[key];
                    }
                }
            }

            if (typeof(open) !== 'undefined') {
                options.open = open;
            }

            //wait for the DOM view to be ready
            $timeout(function () {

                if (!$attributes.ngSrc) {
                    //opens the fancybox using an href.
                    fbp = $($element).fancyboxPlus(options);
                } else {
                    //$element.bind('load', function() {
                    /*$scope.$apply(function () {
                     options.href = $attributes.src ? $attributes.src : $attributes.href;
                     cb = $.colorbox(options);
                     });*/
                    //wait for the DOM view to be ready
                    $timeout(function () {
                        options.href = $attributes.src ? $attributes.src : $attributes.href;
                        fbp = $($element).fancyboxPlus(options);
                    }, 300);
                    //});
                }


            }, 0);
        }

        function onComplete() {
            $rootScope.$apply(function () {
                let content = $('#fbplus-content');
                $compile(content)($rootScope);
            });
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/modules/fancybox-plus/fancyboxable.directive.js